"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _apollo = require("@nerdwallet/apollo");
var _currency = require("@nerdwallet/currency");
var _reactChiclet = _interopRequireDefault(require("@nerdwallet/react-chiclet"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _bainComponents = require("@nerdwallet/bain-components");
var _bankingDriverModule = _interopRequireDefault(require("./banking-driver.module.css"));
var _templateObject;
var BankingDriver = function BankingDriver(_ref) {
  var driver = _ref.driver,
    renderDivider = _ref.renderDivider,
    isLimitedTimeOffer = _ref.isLimitedTimeOffer;
  var label = driver.label,
    description = driver.description,
    value = driver.value,
    valueTooltip = driver.valueTooltip;
  var isBonusOffer = label === 'Bonus' && value;
  return /*#__PURE__*/_react.default.createElement(_currency.Stack, {
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_currency.Box, {
    paddingY: 1
  }, /*#__PURE__*/_react.default.createElement(_currency.Columns, null, /*#__PURE__*/_react.default.createElement(_currency.Column, {
    width: "3"
  }, /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small",
    tone: "light"
  }, label)), /*#__PURE__*/_react.default.createElement(_currency.Column, {
    width: "9"
  }, /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Text, null, value || 'N/A'), valueTooltip && /*#__PURE__*/_react.default.createElement(_currency.Tooltip, {
    placement: "bottom",
    content: /*#__PURE__*/_react.default.createElement(_currency.Box, {
      className: _bankingDriverModule.default.tooltip
    }, valueTooltip)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classes.default)(['padding-left-1', 'vertical-align-bottom'])
  }, isBonusOffer && !isLimitedTimeOffer && /*#__PURE__*/_react.default.createElement(_reactChiclet.default, {
    text: "Bonus offer",
    color: "purple-lightest",
    type: "tall"
  }), isBonusOffer && isLimitedTimeOffer && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classes.default)(['padding-vertical-1'])
  }, /*#__PURE__*/_react.default.createElement(_bainComponents.Chiclet, null)))), description && /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small",
    tone: "light"
  }, description)))), renderDivider && /*#__PURE__*/_react.default.createElement(_currency.Box, {
    paddingY: 1
  }, /*#__PURE__*/_react.default.createElement(_currency.Divider, {
    level: 2
  }))));
};
BankingDriver.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment BankingDriver on MarketplaceEntityWithPlacementInterface {\n    placementDrivers {\n      description\n      label\n      value\n      ... on EntityPlacementDriver {\n        valueTooltip\n      }\n    }\n  }\n"])));
var _default = BankingDriver;
exports.default = _default;